/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
  m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
  m11ReportSection09FoiChanged, m11ReportSection09ResourceChanged, selectM11ReportContainerFoi,
  selectM11ReportContainerResource, selectM11ReportSection09Foi, selectM11ReportSection09Resource,
  selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveAdverseEventsChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
  section09State, setAlertModalState, setStartingSection09State) => {

  let changesStates = {
    section09State: section09State
  };
  let response = await saveM11Changes(apiToken, 32, m11ResearchStudyFoi, changesStates);
  if (response?.success) {
    if (response.m11ReportContainerResource) {
      dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
    }
    if (response.m11ReportSection09Resource) {
      dispatch(m11ReportSection09ResourceChanged(response.m11ReportSection09Resource));
    }
    setStartingSection09State(JSON.parse(JSON.stringify(section09State)));
  } else {
    if (response.error) {
      alert(response.error);
    }
  }
};

const M11Step032CompleteAdverseEvents = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

  const dispatch = useDispatch();
  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11User = useSelector(selectCurrentUserM11Use);
  const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
  const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
  const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
  const m11ReportSection09Foi = useSelector(selectM11ReportSection09Foi);
  const m11ReportSection09Resource = useSelector(selectM11ReportSection09Resource);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [section09State, setSection09State] = useState({
    "section931Status": "empty", "section931Xhtml": "",
    "section932Status": "empty", "section932Xhtml": "",
    "section94Status": "empty", "section94Xhtml": ""
  });
  const [startingSection09State, setStartingSection09State] = useState({
    "section931Status": "empty", "section931Xhtml": "",
    "section932Status": "empty", "section932Xhtml": "",
    "section94Status": "empty", "section94Xhtml": ""
  });
  const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

  useImperativeHandle(ref, () => ({
    unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section09State, startingSection09State)),
    async saveAllChanges() {
      await saveAdverseEventsChanges(dispatch, apiToken, m11ResearchStudyFoi,
        section09State, setAlertModalState, setStartingSection09State);
    }
  }));

  useEffect(() => {
    if (m11ResearchStudyResource?.id) {
      let m11ReportFoi = "";
      if (m11ResearchStudyResource.relatesTo?.length > 0) {
        for (let relatesTo of m11ResearchStudyResource.relatesTo) {
          if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
            relatesTo.targetReference) {
            m11ReportFoi = getIdFromReference(relatesTo.targetReference);
          }
        }
      }
      if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
        dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ResearchStudyResource]);

  useEffect(() => {
    if (initialCalculationNeeded === true) {
      let startingData = {
        "section931Status": "empty", "section931Xhtml": "",
        "section932Status": "empty", "section932Xhtml": "",
        "section94Status": "empty", "section94Xhtml": "",
        "loaded": true
      };
      setSection09State(startingData);
      setStartingSection09State(startingData);
    }
  }, [initialCalculationNeeded]);

  useEffect(() => {
    if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
      loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
    }
  }, [m11ReportContainerFoi]);

  useEffect(() => {
    if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
      if (m11ReportContainerResource.section?.[9]?.entry?.length) {
        let m11ReportSection009Foi = getIdFromReference(m11ReportContainerResource.section[9].entry[0]);
        if (m11ReportSection009Foi && !isNaN(m11ReportSection009Foi) && m11ReportSection009Foi !== m11ReportSection09Foi) {
          dispatch(m11ReportSection09FoiChanged(m11ReportSection009Foi));
        } else {
          setInitialCalculationNeeded(true);
        }
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportContainerResource]);

  useEffect(() => {
    if (m11ReportSection09Foi && !isNaN(m11ReportSection09Foi)) {
      loadResource(m11ReportSection09Foi, "M11ReportSection09", apiToken, dispatch);
    }
  }, [m11ReportSection09Foi]);

  useEffect(() => {
    if (m11ReportSection09Resource && Object.keys(m11ReportSection09Resource).length > 0) {
      let startingData = {
        "section931Status": "empty", "section931Xhtml": "",
        "section932Status": "empty", "section932Xhtml": "",
        "section94Status": "empty", "section94Xhtml": "",
        "loaded": true
      };
      if (m11ReportSection09Resource.section?.[0]?.section?.length > 0) {
        if (m11ReportSection09Resource.section[0].section[2]?.section?.length > 0) {
          if (m11ReportSection09Resource.section[0].section[2].section[0]?.text?.div &&
            m11ReportSection09Resource.section[0].section[2].section[0].text.status !== "empty") {
            startingData.section931Status = m11ReportSection09Resource.section[0].section[2].section[0].text.status;
            startingData.section931Xhtml = m11ReportSection09Resource.section[0].section[2].section[0].text.div;
          }
          if (m11ReportSection09Resource.section[0].section[2].section[1]?.text?.div &&
            m11ReportSection09Resource.section[0].section[2].section[1].text.status !== "empty") {
            startingData.section932Status = m11ReportSection09Resource.section[0].section[2].section[1].text.status;
            startingData.section932Xhtml = m11ReportSection09Resource.section[0].section[2].section[1].text.div;
          }
        }
        if (m11ReportSection09Resource.section[0].section[3]?.text?.div &&
          m11ReportSection09Resource.section[0].section[3].text.status !== "empty") {
          startingData.section94Status = m11ReportSection09Resource.section[0].section[3].text.status;
          startingData.section94Xhtml = m11ReportSection09Resource.section[0].section[3].text.div;
        }
        setSection09State(startingData);
        setStartingSection09State(startingData);
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportSection09Resource]);

  return <div>
    <h3>Complete Section 9 ADVERSE EVENTS, SERIOUS ADVERSE EVENTS, PRODUCT COMPLAINTS, PREGNANCY AND POSTPARTUM INFORMATION, AND SPECIAL SAFETY SITUATIONS</h3>
        {!(m11ReportSection09Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
    {m11User === "sample" ?
      <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
        <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
        <p style={{ color: "red" }}>Step 32 (Complete Section 9 ADVERSE EVENTS, SERIOUS ADVERSE EVENTS, PRODUCT COMPLAINTS, PREGNANCY AND POSTPARTUM INFORMATION, AND SPECIAL SAFETY SITUATIONS) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
        <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
      </div>
      :
      <>
        {section09State.loaded && <>
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 9.3.1 Participants Who Become Pregnant During the Trial as needed.</h4>
          <TextDivEntry elementName="section931Xhtml"
            startingValue={section09State.section931Xhtml}
            setResourceState={setSection09State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 9.3.2 Participants Whose Partners Become Pregnant During the Trial as needed.</h4>
          <TextDivEntry elementName="section932Xhtml"
            startingValue={section09State.section932Xhtml}
            setResourceState={setSection09State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 9.4 Special Safety Situations as needed.</h4>
          <TextDivEntry elementName="section94Xhtml"
            startingValue={section09State.section94Xhtml}
            setResourceState={setSection09State} />
        </>}
      </>
    }
  </div >
});

const M11Step032CompleteAdverseEventsHelperText = <div>
  <h3>Complete Section 9 ADVERSE EVENTS, SERIOUS ADVERSE EVENTS, PRODUCT COMPLAINTS, PREGNANCY AND POSTPARTUM INFORMATION, AND SPECIAL SAFETY SITUATIONS</h3>
  <div style={{ textAlign: "left" }}>
    <p>If applicable, enter data for Section 9.3.1 Participants Who Become Pregnant During the Trial.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Specify:</p>
      <div style={{ marginLeft: "24px" }} >
        <p>•	the assessments to be performed</p>
        <p>•	type and duration of monitoring</p>
        <p>•	whether participants who become pregnant during the trial may continue with trial intervention or must be discontinued from trial intervention (refer to Section 7 Participant Discontinuation of Trial Intervention and Discontinuation or Withdrawal from Trial as applicable)</p>
        <p>•	any trial modifications that need to be made for participants who become pregnant</p>
        <p>•	what information will be collected about a participant who becomes pregnant during the trial (e.g., recording and reporting to the sponsor, postpartum follow-up, trial intervention discontinuation or continuation, or trial withdrawal)</p>
      </div>
      <p>For postpartum follow-up, include the time period (e.g., initial child development) with justification.</p>
      <p>If exposure to trial intervention during breastfeeding is applicable, specify:</p>
      <div style={{ marginLeft: "24px" }} >
        <p>•	the assessments to be performed</p>
        <p>•	type and duration of monitoring</p>
        <p>•	information to be collected for both the participant and child</p>
      </div>
    </div>
    <p>If applicable, enter data for Section 9.3.2 Participants Whose Partners Become Pregnant During the Trial.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Specify:</p>
      <div style={{ marginLeft: "24px" }} >
        <p>•	whether the investigator will attempt to collect pregnancy information about a participant’s partner who becomes pregnant during the specified period in the trial</p>
        <p>•	whether the participant whose partner becomes pregnant should be discontinued from trial intervention (refer to Section 7 Participant Discontinuation of Trial Intervention and Discontinuation or Withdrawal from Trial as applicable)</p>
        <p>•	the assessments to be performed, type and duration of monitoring, and the information to be collected</p>
      </div>
    </div>
    <p>Enter data for Section 9.4 Special Safety Situations.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Specify special safety situations associated with the trial intervention(s) that do not qualify as an AE or SAE, but require regulatory reporting. Examples include:</p>
      <div style={{ marginLeft: "24px" }} >
        <p>•	misuse or abuse</p>
        <p>•	off-label use (if applicable)</p>
        <p>•	medication error (prescription or dispensing error)</p>
        <p>•	occupational exposure</p>
        <p>•	use outside of what is foreseen in the protocol</p>
        <p>•	unintended exposure of embryo, foetus, or child via maternal exposure (pregnancy or breastfeeding) or via paternal exposure (semen)</p>
        <p>•	lack of therapeutic efficacy; this is not applicable for studies that measure efficacy as a study endpoint</p>
        <p>•	suspected transmission of an infectious agent; this is only applicable for injected or biologic medicinal products</p>
        <p>•	product complaint, including falsified or counterfeit products</p>
        <p>•	suspected drug-food or drug-drug interaction</p>
      </div>
    </div>
    <p>Click the 'Save All Changes' button.</p>
  </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step032CompleteAdverseEventsValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 32, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
    <h4>Step 32 (Complete Section 9 ADVERSE EVENTS, SERIOUS ADVERSE EVENTS, PRODUCT COMPLAINTS, PREGNANCY AND POSTPARTUM INFORMATION, AND SPECIAL SAFETY SITUATIONS) {validationCheckState.step32numberOfChecks} issues checked. {validationCheckState.step32numberPassed} passed. {validationCheckState.step32numberFailed} failed.</h4>
    <p>Section 9 heading is 'ADVERSE EVENTS, SERIOUS ADVERSE EVENTS, PRODUCT COMPLAINTS, PREGNANCY AND POSTPARTUM INFORMATION, AND SPECIAL SAFETY SITUATIONS': {validationCheckState.resultCheckSection9Heading}</p>
    <p>Section 9 ADVERSE EVENTS, SERIOUS ADVERSE EVENTS, PRODUCT COMPLAINTS, PREGNANCY AND POSTPARTUM INFORMATION, AND SPECIAL SAFETY SITUATIONS does not have text: {validationCheckState.resultCheckSection9Text}</p>
    <p>Section 9.3 heading is 'Pregnancy and Postpartum Information': {validationCheckState.resultCheckSection93Heading}</p>
    <p>Section 9.3 Pregnancy and Postpartum Information does not have text: {validationCheckState.resultCheckSection93Content}</p>
    <p>If present, Section 9.3.1 heading is 'Participants Who Become Pregnant During the Trial': {validationCheckState.resultCheckSection931Heading}</p>
    <p>If present, Section 9.3.1 Participants Who Become Pregnant During the Trial has content: {validationCheckState.resultCheckSection931Content}</p>
    <p>If present, Section 9.3.2 heading is 'Participants Whose Partners Become Pregnant During the Trial' or 'Participants Whose Partners Become Pregnant': {validationCheckState.resultCheckSection932Heading}</p>
    <p>If present, Section 9.3.2 Participants Whose Partners Become Pregnant During the Trial has content: {validationCheckState.resultCheckSection932Content}</p>
    <p>Section 9.4 heading is 'Special Safety Situations': {validationCheckState.resultCheckSection94Heading}</p>
    <p>Section 9.4 Special Safety Situations has content: {validationCheckState.resultCheckSection94Content}</p>
    </div>}  </div>
}

export default M11Step032CompleteAdverseEvents;
export { M11Step032CompleteAdverseEventsHelperText, M11Step032CompleteAdverseEventsValidationCheck };